import { Outlet } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Breadcrumbs from "../../components/BreadCrumbs";

export default function MainLayout() {
  return (
    <div className="flex h-screen">
    {/* Sidebar on the left */}
    <div className="w-1/6">
      <Sidebar />
    </div>
  
    {/* Right side: Header on top, Outlet below */}
    <div className="flex flex-col flex-1 w-5/6">
      <Header />
      <Breadcrumbs />
      <main className="flex-1 overflow-auto ">
        <Outlet />
      </main>
    </div>
  </div>
  
  );
}

